import { useStore } from '@hooks/useStore'
import {
  Experimental_CssVarsProvider as CssVarsProvider,
  CssVarsTheme,
  StyledEngineProvider,
} from '@mui/material/styles'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { observer } from 'mobx-react-lite'
import { useEffect, useMemo } from 'react'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import 'src/styles/index.styles.scss'
import { OutvoiceRouter } from './components/core/index.core.component'
import { EVENT_KEYS } from './constants/keys.contants'
import { responsiveTheme } from './styles/theme/theme'
import { getFromStorage } from '@helpers/storage.helpers'
import { useInactivityWarning } from '@hooks/useInactivityWarning'
import { InactivityWarningModal } from './components/features/inactivity-warning/InactivityWarningModal'

const App = observer(() => {
  const { auth } = useStore()
  const isMobile = useMemo(() => window.matchMedia('(max-width: 900px)').matches, [window.innerWidth])
  const { showWarning, secondsRemaining, extendSession, handleLogout } = useInactivityWarning()

  useEffect(() => {
    // Store event handlers in constants to ensure same reference for add/remove
    const handleNewToken = (e: any) => {
      console.log('[Token Rotation] New token received, updating stored token')
      auth.refreshToken(e.detail)
    }

    const handleLogout = () => {
      const unauth = getFromStorage(EVENT_KEYS.UNAUTH)
      console.log('[Logout Event] unauth flag:', unauth)
      if (!unauth) {
        auth.logout(true)
      }
    }

    window.addEventListener(EVENT_KEYS.NEW_TOKEN, handleNewToken)
    window.addEventListener(EVENT_KEYS.LOGOUT, handleLogout)

    return () => {
      window.removeEventListener(EVENT_KEYS.NEW_TOKEN, handleNewToken)
      window.removeEventListener(EVENT_KEYS.LOGOUT, handleLogout)
    }
  }, [])
  return (
    <StyledEngineProvider injectFirst>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <CssVarsProvider theme={responsiveTheme as unknown as CssVarsTheme}>
          <div className="App">
            <OutvoiceRouter />
          </div>
          <ToastContainer
            position={'bottom-right'}
            style={{
              marginBottom: isMobile ? '56px' : 'initial',
            }}
          />
          <InactivityWarningModal
            open={showWarning}
            onExtendSession={extendSession}
            onLogout={handleLogout}
            secondsRemaining={secondsRemaining}
          />
        </CssVarsProvider>
      </LocalizationProvider>
    </StyledEngineProvider>
  )
})

export default App
